import { createScopedLogger } from 'pi-kiosk-shared/logging';
import { customerLogger } from '../../shared/logging/customerLogger.js';

export const oidcLog = createScopedLogger(customerLogger, { module: 'auth', feature: 'oidc' });
